import { MailInfo } from 'models/interfaces';
import api from '../hooks/base-api'
import { SHARE_PERM_DROPDOWN } from 'utils/constants';

const getShareChatList = (): Promise<any> => {
  return api.get('/v0/share_drives');
}

const putSharedUsers = (data: MailInfo[], id: string, role: SHARE_PERM_DROPDOWN): Promise<any> => {
  return api.post(`/v0/drive/${id}/shared_users`, { data, role })
};

const getSharedUsers = (id: string): Promise<any> => {
  return api.get(`/v0/drive/${id}/shared_users`)
};

const getSuggestionUsers = (): Promise<any> => {
  return api.get(`/v0/drive/users`)
};

const deleteSharedUsers = (id: string, user_id: number): Promise<any> => {
  return api.delete(`/v0/drive/${id}/shared_users`, { params: { id: user_id } })
};

const changeRoleSharedUsers = (id: string, user_id: number, role: string): Promise<any> => {
  return api.put(`/v0/drive/${id}/shared_users`, { role }, { params: { id: user_id } })
};

export {
  getShareChatList,
  putSharedUsers,
  getSharedUsers,
  getSuggestionUsers,
  deleteSharedUsers,
  changeRoleSharedUsers
};
